var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDetailArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.548247 1.6783L2.68825 3.8183L3.99491 5.13163C4.54825 5.68496 5.44825 5.68496 6.00158 5.13163L9.45491 1.6783C9.90825 1.22496 9.58158 0.451631 8.94825 0.451631L5.20825 0.451631L1.05491 0.45163C0.414914 0.45163 0.0949129 1.22496 0.548247 1.6783Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailArrowDown);
export default __webpack_public_path__ + "static/media/order-detail-arrow-down.e9592e292e3e76a2b6c4c68f73808fd9.svg";
export { ForwardRef as ReactComponent };